import { render, staticRenderFns } from "./DeleteCategoryDialog.vue?vue&type=template&id=34c4e750&scoped=true&"
import script from "./DeleteCategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteCategoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c4e750",
  null
  
)

export default component.exports